import { AffiliateOfferTable } from "components/Tables/AffiliateOfferTable/AffiliateOfferTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getAffiliateHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/")({
    component: AffiliateOfferRequestsPage,
    staticData: {
        permissions: [PermissionEnum.AffiliateOfferRequestsView],
        showInSideMenu: false,
        label: "pages.affiliate.request.offer.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.affiliate.request.offer.title"),
        };
    },
});

function AffiliateOfferRequestsPage() {
    return (
        <TenantPage headerNavigationItems={getAffiliateHeaderItems}>
            <AffiliateOfferTable />
        </TenantPage>
    );
}
